import { PROMOTION_ACTION_TYPES } from './types';
import promotionService from '../services/promotionService';

/**
 * Fetch promotion data action
 * @param {string} userId - User ID to fetch promotion data for
 * @returns {Function} Redux thunk function
 */
export const fetchPromotion = (userId) => async (dispatch) => {
  dispatch({ type: PROMOTION_ACTION_TYPES.FETCH_PROMOTION_REQUEST });

  try {
    const response = await promotionService.getPromotion(userId);

    if (response.success) {
      dispatch({
        type: PROMOTION_ACTION_TYPES.FETCH_PROMOTION_SUCCESS,
        payload: {
          data: response.data,
          message: response.message
        }
      });

      return { success: true, data: response.data };
    } else {
      dispatch({
        type: PROMOTION_ACTION_TYPES.FETCH_PROMOTION_FAILURE,
        payload: {
          error: response.message || 'Failed to fetch promotion data',
          status: response.status
        }
      });

      return { success: false, error: response.message };
    }
  } catch (error) {
    dispatch({
      type: PROMOTION_ACTION_TYPES.FETCH_PROMOTION_FAILURE,
      payload: {
        error: error.message || 'An unexpected error occurred while fetching promotion data',
        status: error.status || 500
      }
    });

    return { success: false, error: error.message };
  }
};

/**
 * Create promotion action (without dispatch)
 * @param {Object} promotionData - Promotion data to create
 * @returns {Promise<Object>} Create result
 */
export const createPromotion = async (promotionData) => {
  try {
    const response = await promotionService.createPromotion(promotionData);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Cancel promotion action (without dispatch)
 * @param {string} promotionId - Promotion ID to cancel
 * @returns {Promise<Object>} Cancel result
 */
export const cancelPromotion = async (promotionId) => {
  try {
    const response = await promotionService.cancelPromotion(promotionId);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Check promotion action (without dispatch)
 * @param {string} creatorId - Creator ID to check promotion data for
 * @returns {Promise<Object>} Check result
 */
export const checkPromotion = async (creatorId) => {
  try {
    const response = await promotionService.checkPromotion(creatorId);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Clear promotion errors action
 * @returns {Object} Action object
 */
export const clearPromotionErrors = () => ({
  type: PROMOTION_ACTION_TYPES.CLEAR_PROMOTION_ERRORS
});

